import React, { useState, memo } from "react";
import PropTypes from "prop-types";
import ReactModal from "react-modal";
import styled from "styled-components";
import { MODAL_STYLES } from "../../constants";
import "./Renderables.css";

const ModalHeader = styled.div`
  background: #CE0E2D;
  color: white;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  font-size: 1em;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 1.4em;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  opacity: 0.8;
  transition: opacity 0.15s;

  &:hover {
    opacity: 1;
  }
`;

const ModalBody = styled.div`
  padding: 20px 20px 24px;
  text-align: center;
`;

const DescriptionText = styled.p`
  margin: 0;
  font-size: 0.95em;
  font-weight: 600;
  color: #333;
  line-height: 1.6;
`;

const FooterBar = styled.div`
  padding: 12px 20px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
`;

const CloseBtn = styled.button`
  background: white;
  color: #555;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 6px 20px;
  font-size: 0.85em;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    background: #f3f4f6;
    border-color: #999;
    color: #333;
  }
`;

export const RenderVehicleTypeAndDescription = memo(({ row }) => {
  const { original } = row;
  const {
    primaryVehicleTypeAbbr: primaryVehicleType,
    primaryVehicleTypeDesc: primaryVehicleTypeDescription,
    secondaryVehicleTypeAbbr: secondaryVehicleType,
    secondaryVehicleTypeDesc: secondaryVehicleTypeDescription,
  } = original;

  const [vehicleDescription, setVehicleDescription] = useState(null);

  return (
    <>
      {vehicleDescription && (
        <ReactModal
          isOpen={vehicleDescription !== null}
          style={MODAL_STYLES}
          onRequestClose={() => setVehicleDescription(null)}
          appElement={document.getElementById("root")}
        >
          <ModalHeader>
            Vehicle Type
            <CloseButton onClick={() => setVehicleDescription(null)}>&times;</CloseButton>
          </ModalHeader>
          <ModalBody>
            <DescriptionText>{vehicleDescription}</DescriptionText>
          </ModalBody>
          <FooterBar>
            <CloseBtn onClick={() => setVehicleDescription(null)}>Close</CloseBtn>
          </FooterBar>
        </ReactModal>
      )}
      <div>
        <button
          type="button"
          title={primaryVehicleType}
          className={primaryVehicleTypeDescription ? "vehicle-type-label vehicle-type-button" : "vehicle-type-button"}
          onClick={() => setVehicleDescription(primaryVehicleTypeDescription)}
        >
          {primaryVehicleType}
        </button>
        {secondaryVehicleType && (
          <>
            {" "}
            <span> - </span>
            <button
              type="button"
              title={secondaryVehicleType}
              className={
                secondaryVehicleTypeDescription ? "vehicle-type-label vehicle-type-button" : "vehicle-type-button"
              }
              onClick={() =>
                setVehicleDescription(secondaryVehicleTypeDescription)
              }
            >
              {secondaryVehicleType}
            </button>
          </>
        )}
      </div>
    </>
  );
});

RenderVehicleTypeAndDescription.displayName = "RenderVehicleTypeAndDescription";

RenderVehicleTypeAndDescription.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      primaryVehicleTypeAbbr: PropTypes.string,
      primaryVehicleTypeDesc: PropTypes.string,
      secondaryVehicleTypeAbbr: PropTypes.string,
      secondaryVehicleTypeDesc: PropTypes.string,
    }).isRequired,
  }).isRequired,
};
